import React, {useState} from 'react';
import {
  Text,
  Linking,
  ScrollView,
  Pressable,
  StyleProp,
  ViewStyle,
  View,
  DimensionValue,
} from 'react-native';
import {Table, Row} from 'react-native-table-component';
import {Picker} from '@react-native-picker/picker';
import CCText from '../CCText';
import Box from '../Box';
import CCColors, {updateColorWithOpacity} from '@/Utils/CCColors';
import {StyleSheet} from 'react-native';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import {useNavigation} from '@react-navigation/native';
import {ScreenName} from '@/navigators/StackConstants';
import {vs} from '@/Utils/Dimensions';
interface CustomCellProps {
  item: {
    name: string;
    type: 'text' | 'link' | 'dropdown' | 'highlighted_text';
    url?: string;
    options?: string[];
  };
}

export const CustomCell: React.FC<CustomCellProps> = ({item}) => {
  switch (item.type) {
    case 'text':
      return <CCText>{item.name}</CCText>;
    case 'dropdown':
      return (
        <Picker selectedValue={item.name}>
          {item.options?.map((option, index) => (
            <Picker.Item key={index} label={option} value={option} />
          ))}
        </Picker>
      );
    case 'link':
      return (
        <Text
          style={{color: 'blue'}}
          onPress={() => item.url && Linking.openURL(item.url)}>
          {item.name}
        </Text>
      );
    case 'highlighted_text':
      return (
        <Box
          style={{backgroundColor: CCColors.GamesList.Background, padding: 0}}>
          <CCText>{item.name}</CCText>
        </Box>
      );
    default:
      return <Text>{item.name}</Text>;
  }
};

interface CCPackageTableProps {
  headers: string[];
  tableData: Array<
    Array<{
      name: string;
      type: 'text' | 'link' | 'dropdown';
      url?: string;
      options?: string[];
    }>
  >;
  flexArr?: number[];
  headerTextColor?: string;
  borderBottomColor?: string;

  borderBottomWidth?: boolean;
  isMargin?: boolean;
  isPadding?: boolean;
  jsxTable?: boolean;
  handleRowPress?: (rowIndex: number) => void;
  currentPage?: number;
  headerStyle?: {};
  margin?: number;
  tournament?: boolean;
  backgroundColorRow?: boolean;
  headerHeight?: number;
  tableBorder?: boolean;
  border?: boolean;
  higlightedRow?: number[];
  highlightedBorder?: boolean;
  tablePadding?: boolean;
  tableShadow?: boolean;
  customCellBlock?: StyleProp<ViewStyle>;
  customBlockRow?: StyleProp<ViewStyle>;
  isSecondLastRow?: boolean;
  criticalRows?: number[];
  isBorderBottomRow?: boolean;
  customBorderwidth?: DimensionValue;
  customLeft?: DimensionValue;
  shiftHeaders?: boolean;
}

const CCPackageTable: React.FC<CCPackageTableProps> = ({
  headers,
  tableData,
  headerTextColor = CCColors.TextColor.Dark,
  borderBottomColor = CCColors?.Primary,
  borderBottomWidth = true,
  isMargin = true,
  flexArr = [],
  isPadding = false,
  jsxTable,
  handleRowPress,
  currentPage,
  headerStyle = {},
  margin = 10,
  tournament = false,
  backgroundColorRow = false,
  tableBorder = true,
  border = false,
  headerHeight,
  higlightedRow,
  highlightedBorder,
  tablePadding,
  tableShadow,
  customBlockRow,
  customCellBlock,
  isSecondLastRow,
  criticalRows = [],
  isBorderBottomRow,
  customBorderwidth,
  customLeft,
  shiftHeaders = false,
  ...rest
}) => {
  const navigation = useNavigation();
  const {isMobileOrTab} = useMediaQuery();
  const formattedData = tableData.map(row =>
    row.map(item => <CustomCell key={item.name} item={item} />),
  );
  const [hoveredRow, setHoveredRow] = useState(null);
  console.log('bottom color', borderBottomColor, headerTextColor);

  return (
    <ScrollView
      showsVerticalScrollIndicator={!isMobileOrTab ? false : undefined}
      style={{width: '100%'}}>
      <Box
        style={[
          styles.wrapper,
          {margin: margin, borderWidth: tableBorder ? 1 : 0},
        ]}
        {...rest}>
        {isMobileOrTab && !tournament ? (
          // Render each row as a block if on a small screen
          formattedData.map((rowData, index) => (
            <Box key={index} style={[styles.blockRow, customBlockRow]}>
              {rowData.map((cell, cellIndex) => (
                <Box
                  key={cellIndex}
                  style={[styles.cellBlock, customCellBlock]}>
                  {cell}
                </Box>
              ))}
            </Box>
          ))
        ) : (
          // Render the normal table if not on a small screen
          <>
            <Table
              borderStyle={{
                borderBottomWidth: 1,
                backgroundColor: 'red',
              }}>
              <Row
                data={headers}
                style={[
                  styles.head,
                  {
                    borderBottomWidth: 0,
                    backgroundColor: 'white',
                    height: headerHeight || 40,
                  },
                  tablePadding && {
                    padding: vs(22),
                  },
                ]}
                flexArr={flexArr}
                textStyle={[
                  styles.text,
                  {color: headerTextColor},
                  shiftHeaders && {textAlign: 'center'},
                  headerStyle,
                ]}
              />
            </Table>
            {formattedData?.length > 0 ? (
              <ScrollView
                style={[styles.dataWrapper]}
                showsVerticalScrollIndicator={false}>
                <Table borderStyle={{borderBottomWidth: 1}}>
                  {formattedData.map((rowData, index) =>
                    jsxTable ? (
                      <Pressable
                        key={index}
                        onPress={() => handleRowPress && handleRowPress(index)}
                        onHoverIn={() => setHoveredRow(index)}
                        onHoverOut={() => setHoveredRow(null)}
                        style={[
                          styles.row,
                          index % 2 === 0 && {
                            backgroundColor: 'white',
                          },
                          hoveredRow === index &&
                            ({
                              backgroundImage:
                                'linear-gradient(90deg, rgba(250, 246, 235, 0) 0%, #FAF6EB 50%, rgba(250, 246, 235, 0) 100%)',
                              cursor: 'pointer',
                            } as any),
                          higlightedRow?.includes(index) && {
                            backgroundColor: CCColors.HighlightColor,
                          },
                        ]}>
                        <Row
                          flexArr={flexArr}
                          key={index}
                          data={rowData}
                          textStyle={{
                            margin: 6,
                            fontWeight: '500',
                          }}
                        />
                      </Pressable>
                    ) : (
                      <Pressable
                        key={index}
                        onPress={() => handleRowPress && handleRowPress(index)}>
                        <Row
                          style={[
                            styles.row,
                            index % 2 !== 0
                              ? {
                                  backgroundColor: backgroundColorRow
                                    ? CCColors.CCTableBg
                                    : 'white',
                                }
                              : null,
                            higlightedRow?.includes(index) && {
                              backgroundColor: CCColors.HighlightColor, // <-- Highlight this row in red
                            },
                            criticalRows?.includes(index) && {
                              backgroundColor: CCColors.WrongMoves.Background, // Light red background
                            },
                            {
                              borderBottomColor: borderBottomColor,
                              borderBottomWidth: border ? 1 : 0,
                              // margin: isMargin ? 5 : 0,
                              // padding: isMargin ? 0 : 10,
                              padding: isMargin ? 0 : isPadding ? 10 : 0,
                            },
                            higlightedRow?.[0] === index && {
                              borderTopWidth: highlightedBorder ? 2 : 0,
                              borderTopColor: CCColors?.Green,
                              borderBottomWidth: highlightedBorder ? 2 : 0,
                              borderBottomColor: CCColors?.Green,
                            },
                            // isSecondLastRow && {
                            //   borderLeftWidth: 2,
                            //   borderLeftColor: 'black',
                            // },
                          ]}
                          flexArr={flexArr}
                          key={index}
                          data={
                            isSecondLastRow
                              ? rowData?.map((cell, cellIndex) => (
                                  <View key={cellIndex} style={styles.cell}>
                                    <CCText style={styles.text}>{cell}</CCText>

                                    {cellIndex === flexArr.length - 2 && (
                                      <View style={styles.shadow} />
                                    )}
                                  </View>
                                ))
                              : rowData
                          }
                          textStyle={styles.text}
                        />
                        {isBorderBottomRow && (
                          <View
                            style={[
                              styles.customBottomBorder,
                              {
                                left:
                                  customLeft ??
                                  `${
                                    (flexArr[0] /
                                      flexArr.reduce((a, b) => a + b, 0)) *
                                    100
                                  }%`,
                                width: customBorderwidth ?? '85%',
                              },
                            ]}
                          />
                        )}
                      </Pressable>
                    ),
                  )}
                </Table>
              </ScrollView>
            ) : (
              <CCText
                color={CCColors.Grey.Grey}
                textAlign="center"
                style={{marginVertical: 30}}>
                No data available
              </CCText>
            )}
          </>
        )}
      </Box>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    // flexDirection: 'row',
    borderWidth: 1,
    // width: '95%',
    // borderColor: CCColors.TextColor.Grey,
    borderColor: 'rgba(0,0,0,0.1)',
    // margin: 'auto',
    borderRadius: 8,
  },
  tableHeader: {
    borderWidth: 0,
    borderColor: 'transparent',
    // width: '95%',
  },
  dataWrapper: {
    // marginTop: -1,
    borderWidth: 0,
  },
  head: {
    height: 40,
    backgroundColor: CCColors.Primary.Light,
    // borderBottomWidth: 1,
    borderColor: CCColors.TextColor.Grey,
  },
  text: {
    margin: 6,
    // color: CCColors.TextColor.Dark,
    fontWeight: '500',
  },
  row: {
    borderBottomWidth: 1,
    borderBottomColor: updateColorWithOpacity(CCColors?.Grey.Grey, 0.3),
    // borderWidth: 0,
    minWidth: 200,
    // margin: 5,
    // padding: 10,
  },
  blockRow: {
    flexDirection: 'column',
    margin: 5,
    borderWidth: 1,
    borderColor: CCColors.TextColor.Grey,
    borderRadius: 8,
  },
  cellBlock: {
    borderBottomWidth: 1,
    borderBottomColor: CCColors.TextColor.Grey,
    padding: 10,
  },
  // Remove the last borderBottom for the last cellBlock
  lastCellBlock: {
    borderBottomWidth: 0,
  },
  cell: {
    justifyContent: 'center',
    alignItems: 'flex-start',
    alignSelf: 'stretch', // 👈 makes the cell fill row height
    flex: 1, // 👈 ensures even height distribution
    paddingVertical: 0, // 👈 remove vertical padding
    paddingHorizontal: 0, // 👈 optional
    margin: 0,
  },
  shadow: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    width: 1, // wider for visible shadow
    backgroundColor: CCColors.BorderLight,
    shadowColor: CCColors.Black,
    shadowOffset: {width: 5, height: 0},
    shadowOpacity: 0.4,
    shadowRadius: 12, // increase for soft blur
    elevation: 5,
  },
  customBottomBorder: {
    position: 'absolute',
    bottom: 0,
    // width: '85%', // Stretches to 80% from starting point
    height: StyleSheet.hairlineWidth,
    backgroundColor: CCColors.BorderLight, // or your desired color
  },
});

export default CCPackageTable;
